import { DialogActions } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import RiskReviews from 'pages/Finance/Components/Financing/common/Risk';
import React from 'react';

const Evaluations = (props: any) => {
  const { selectedRequest, setOpenShoppingCart } = props;
  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            {' '}
            Salir{' '}
          </CustomButton>
        </DialogActions>
      </div>
    );
  };
  return (
    <ImportedModuleLayout>
      <RiskReviews
        item={selectedRequest}
        requestTypes={['factoring-request', 'factoring-request-payers']}
      />
    </ImportedModuleLayout>
  );
};

export default Evaluations;
